exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n.margin-5 {\r\n    margin: 5px !important;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/projects/angular/DineroAgil/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!C:/projects/angular/DineroAgil/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!C:/projects/angular/DineroAgil/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles